export const SITE_SETTINGS = {
  DEVELOPER_MODE: true,
};
export const API = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASE_URL_2: process.env.REACT_APP_BASE_URL_2,
  EVENTS_DEFAULT_COUNTRY_CODE: "IND",
};
